'use client';
import Script from 'next/script';

export default function ElevarScript() {
  return (
    <>
      <Script
        id="elevar-gtm-script"
        type="module"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
              if (typeof Promise.withResolvers !== 'function') {
                Object.defineProperty(Promise, 'withResolvers', {
                  configurable: true,
                  writable: true,
                  value() {
                    let resolve;
                    let reject;

                    const promise = new Promise((res, rej) => {
                      resolve = res;
                      reject = rej;
                    });

                    return { promise, resolve, reject };
                  }
                });
              }

              (async () => {
                const settings = {};
                try {
                  const config = (await import("https://shopify-gtm-suite.getelevar.com/configs/8ee7afe82660f0550a43aca02dab9dc35e4a7618/config.js")).default;
                  const scriptUrl = settings.proxyPath
                    ? settings.proxyPath + config.script_src_custom_pages_proxied
                    : config.script_src_custom_pages;
                  if (scriptUrl) {
                    const { handler } = await import(scriptUrl);
                    await handler(config, settings);
                  }
                } catch (err) {
                  console.error('Elevar GTM Error. Could be blocked by user.', err);
                }
              })();
            `
        }}
        onLoad={() => {
          if (typeof window !== 'undefined') {
            window?.ElevarInvalidateContext?.();
          }
        }}
      />{' '}
    </>
  );
}
